import React, { useState, useRef, useEffect } from "react";
import "./styles.css";
import logo from "../../../public/assets/loogo.png";
import hamburgerIcon from "../../../public/assets/icon/hamburger.png";
import enFlag from "../../../public/assets/en-flag.png";
import esFlag from "../../../public/assets/spain-flag.png";
import logout from "../../../public/assets/icon/logOut.png";
import MobileSelectFlags from "../mobileSelectFlags";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { googleLogout } from "@react-oauth/google";

function MobileMenu() {
  const [t, i18n] = useTranslation();
  const [isOpenMobile, setIsOpenMobile] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);
  const hoverTargetRef = useRef(null);
  const provider = localStorage.getItem("provider");
  const handleLogout = async () => {
    const accessToken = localStorage.getItem("authToken");

    if (provider === "google") {
      try {
        googleLogout();
      } catch (e) {
        console.error("Google logout failed:", e);
      }
    }

    localStorage.removeItem("authToken");
    localStorage.removeItem("provider");

    try {
      if (accessToken) {
        await axios.post(process.env.BACK_RND_URL+"/auth/logout", {}, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        });
      }
    } catch (error) {
      console.error("Backend logout failed:", error);
    } finally {
      window.location.href = '/'; 
    }
  };

  const toggleMenu = (event) => {
    setIsOpenMobile((prevIsOpenMobile) => !prevIsOpenMobile);
    setIsLangOpen(false);
  };

  const toggleLang = (event) => {
    event.stopPropagation();
    setIsLangOpen((prevIsLangOpen) => !prevIsLangOpen);
  };

  useEffect(() => {
  }, [isOpenMobile]);

  return (
    <div className="mobile-header">
      <div className="hamburger-icon" onClick={toggleMenu}>
        <img src={hamburgerIcon} alt="Menu" />
      </div>
      <div className="logo-container">
        <img className="logo" src={logo} alt="Logo" />
      </div>
      {isOpenMobile && (
        <div className="mobile-menu" ref={hoverTargetRef}>
          <div className="mobile-menu-item" onClick={toggleLang}>
            <MobileSelectFlags isLangOpen={isLangOpen} />
          </div>
          {isLangOpen && (
            <div className="mobile-lang-options">
              <div value="us" className="flag-option selected">
                <img src={enFlag} alt="US Flag" className="flag-icon" />{" "}
                {t("english")}
              </div>
              <div value="spain" className="flag-option">
                <img src={esFlag} alt="Spain Flag" className="flag-icon" />
                {t("spanish")}
              </div>
            </div>
          )}
          <div className="mobile-menu-line"> </div>
          <button className="logout-button" onClick={handleLogout}>
            <img className="profileIcon" src={logout} alt="Logout" />
            <span className="logout-button-span">{t("logout")}</span>
          </button>
        </div>
      )}
    </div>
  );
}

export { MobileMenu };
